import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonStateService } from '../../services/button-state.service';

@Component({
  selector: 'app-child-side-menu',
  templateUrl: './child-side-menu.component.html',
  styleUrl: './child-side-menu.component.scss'
})
export class ChildSideMenuComponent implements OnDestroy {

  /** Input用:サイドメニュー要素 */
  @Input() inputChildren: any[] = null;
  /** Input用:TopSideComponentから呼び出されたかのフラグ */
  @Input() inputIsTopSideComponent = false;
  /** Input用:全てのサイドメニュー情報 */
  @Input() inputAuthorityList = null;
  /** Input用:表示しないサイドメニュー情報 */
  @Input() inputNotViewList = null;

  /** サイドメニュー要素 */
  children: any[] = null;
  /** TopSideComponentから呼び出されたかのフラグ */
  isTopSideComponent: boolean = false;
  /** 全てのサイドメニュー情報 */
  authorityList: any[] = null;
  /** 表示しないサイドメニュー情報 */
  notViewList: string[] = null;
  /** 画面選択中のItemId */
  selectedItemId: string = '';

  /**
   * コンストラクタ
   * @param {Router} router
   * @memberof ChildSideMenuComponent
   */
  constructor(private buttonStateService: ButtonStateService, private router: Router) {
    this.buttonStateService.selectedButtonId$.subscribe(id => {
      this.selectedItemId = id;
    });
  }

  /**
   * 更新処理
   *
   * @memberof ChildSideMenuComponent
   */
  ngOnChanges(): void {
    this.children = this.inputChildren;
    this.isTopSideComponent = this.inputIsTopSideComponent;
    this.authorityList = this.inputAuthorityList;
    this.notViewList = this.inputNotViewList;
  }

  /**
   * 後処理
   *
   * @memberof ChildSideMenuComponent
   */
  ngOnDestroy(): void {
    // 値の初期化
    this.inputChildren = null;
    this.children = null;
    this.inputIsTopSideComponent = false;
    this.isTopSideComponent = false;
    this.inputAuthorityList = null;
    this.authorityList = null;
    this.inputNotViewList = null;
    this.notViewList = null;
    this.selectedItemId = '';
  }

  /**
   * ItemIdから見たサイドメニュー子要素を取得
   * @memberof ChildSideMenuComponent
   */
  getChildren(itemId: string): any[] {
    return this.authorityList
      .filter(authority => authority.parentItemId === itemId)
      .map(authority => authority);
  }

  /**
   * 画面遷移処理
   * @memberof ChildSideMenuComponent
   */
  onClick(pathInfo: any, itemId: string): void {

    this.buttonStateService.selectButton(itemId);

    if (pathInfo.mode === '' && pathInfo.operationType === '') {
      this.router.navigate([pathInfo.path]);

    } else if (pathInfo.mode !== '' && pathInfo.operationType === '') {
      this.router.navigate([pathInfo.path, {
        mode: pathInfo.mode
      }]);

    } else {
      this.router.navigate([pathInfo.path, {
        mode: pathInfo.mode,
        operationType: pathInfo.operationType
      }]);
    }
  }

  /**
   * 親要素Idに紐づく子要素を返却する。
   * 
   * @param parentItemId 親要素Id
   * @memberof ChildSideMenuComponent
   */
  filterChildren(parentItemId: string): any[] {
    return this.authorityList
      .filter(authority => authority.parentItemId === parentItemId && authority.isChildrenFlg)
      .map(authority => authority);
  }

  /**
   * 選択中のボタンIdを管理する。
   * 
   * @param itemId 要素Id
   * @memberof ChildSideMenuComponent
   */
  isSelected(itemId: string): boolean {
    return this.selectedItemId === itemId;
  }
}
